<template>
    <div v-redirect-if-no-permission:LOCATIONS>
        <DataTable :url="api.ACTIONS.LOCATION_CONTAINERS"
                   :fieldsHiddenMain='["deleted_at"]'
                   :titles="titles"
                   :actionsExtraMain="actionsExtraMain"
                   :formatter="formatter"
                   title="Containers"/>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        components: {DataTable},
        name: "ContainerList",
        title: 'Location Container List',
        computed: {
            titles() {
                return {
                    "id": "#",
                    "created_at": "Date Created",
                    "updated_at": "Date Updated"
                }
            },
            actionsExtraMain() {
                return {
                    edit: {
                        action: (item) => `/location_containers/${item.id}`
                    },
                    add: {
                        link: `/location_containers/add`
                    }
                };
            },
            formatter() {
                return {
                    polygon(polygon) {
                        let smallest = Array(2).fill(Math.pow(2, 32));
                        let biggest = Array(2).fill(-Math.pow(2, 32));
                        for (let arr of polygon.coordinates[0]) {
                            smallest[0] = Math.min(smallest[0], arr[0]);
                            smallest[1] = Math.min(smallest[1], arr[1]);
                            biggest[0] = Math.max(biggest[0], arr[0]);
                            biggest[1] = Math.max(biggest[1], arr[1]);
                        }
                        return `
                            <svg height="75" width="75" viewBox="-75 0 75 75">
                                <polygon points="${polygon.coordinates[0].map(arr => -(biggest[0] - arr[0]) / (biggest[0] - smallest[0]) * 75 + "," + (biggest[1] - arr[1]) / (biggest[1] - smallest[1]) * 75).join(" ")}" style="fill:lime;stroke:purple;stroke-width:1;"/>
                            </svg>
                        `;
                    },
                    centroid(value) {
                        return JSON.stringify(value.coordinates);
                    }
                }
            }
        }

    }
</script>

<style scoped>

</style>